/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_PipelinesInputs */

const cs_nav_pipelines = /** @type {(inputs: Nav_PipelinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipeline`)
};

const en_nav_pipelines = /** @type {(inputs: Nav_PipelinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pipelines`)
};

/**
* | output |
* | --- |
* | "Pipelines" |
*
* @param {Nav_PipelinesInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_pipelines = /** @type {((inputs?: Nav_PipelinesInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_PipelinesInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_pipelines(inputs)
	return cs_nav_pipelines(inputs)
});